'use strict';

const { h, Component } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const { hydrate } = require('@grpn/hydration');

const Search = require('../../search/views/search');
const { pruneData } = require('../../../modules/support/prune-data.js');

const menuItems = [
  {
    page: 'home',
    text: 'HomeLinkText',
    routeKey: 'home',
  },
  {
    page: 'categories',
    text: 'CategoriesLinkText',
    routeKey: 'category',
  },
  {
    page: 'top-offers',
    text: 'TopVouchersLinkText',
    routeKey: 'top_offers',
  },
  {
    page: 'exclusive-offers',
    text: 'ExclusiveOffersLinkText',
    routeKey: 'exclusive_offers',
  },
];

function getMainNavigationItems({ activePage, routes }) {
  return menuItems.map(item => ({
    ...item,
    href: routes[item.routeKey].main,
    active: activePage === item.page ? 'active' : '',
  }));
}

class MainMenu extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { showMerchants: false };

    this.clickHandlerShowMerchants = this.clickHandlerShowMerchants.bind(this);
    this.onWindowClick = this.onWindowClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  render() {
    const { activePage, keyAuthData, routes, isTouch } = this.props;
    const { showMerchants } = this.state;

    const navigationItems = getMainNavigationItems({ activePage, routes });

    return h('.main-menu', [
      h('.main-menu-inner', [
        h(
          '.main-menu-content',
          h(
            'ul.main-menu-list',
            {
              'data-bhw': 'CouponsNav',
            },
            [
              ...navigationItems.map(({ active, text, href, page }) =>
                h('li.main-menu-item', [
                  h(
                    Translate,
                    {
                      tag: 'a',
                      attrs: {
                        href,
                        class: `main-menu-link ${active}`,
                        'data-bhc': `nav:${page}`,
                      },
                    },
                    `js.modules.header.${text}`
                  ),
                ])
              ),
              h('li.main-menu-item', [
                h(
                  'a',
                  {
                    href: 'javascript:void(0)',
                    class: `main-menu-link popular-stores-link
                      ${(showMerchants || activePage === 'all-brands') &&
                        'active'}`,
                    onClick: this.clickHandlerShowMerchants,
                    'data-bhc': 'nav:PopularMerchants',
                  },
                  h(Translate, 'js.modules.header.PopularMerchants')
                ),
                !isTouch ? this.getMerchantsDropdown() : null,
              ]),
            ]
          )
        ),
        isTouch ? this.getMerchantsDropdown() : null,
        h('.main-menu-search', [
          h(Search, {
            keyAuthData,
            routes: pruneData(routes, 'merchant:show'),
          }),
        ]),
      ]),
    ]);
  }

  clickHandlerShowMerchants(ev) {
    const { showMerchants } = this.state;

    ev.stopPropagation();

    this.setState({
      showMerchants: !showMerchants,
    });
  }

  onWindowClick() {
    this.setState({
      showMerchants: false,
    });
  }

  getMerchantList() {
    const { routes, merchants } = this.props;
    const { showMerchants } = this.state;

    if (!showMerchants) {
      return null;
    }

    return merchants.map(merchant =>
      h(
        'a.main-menu-dropdown-link',
        {
          href: routes.merchant.show.replace(
            '{merchantSlug}',
            merchant.merchantSlug
          ),
          'data-bhc': `store:${merchant.merchantSlug}`,
        },
        [
          merchant.merchantName,
          h('span.main-menu-dropdown-icon.icon-arrow-right-large'),
        ]
      )
    );
  }

  handleViewAllClick(event) {
    event.stopPropagation();
    event.currentTarget.click();
  }

  getMerchantsDropdown() {
    const { routes } = this.props;
    const { showMerchants } = this.state;
    const merchantsList = this.getMerchantList();

    if (!showMerchants) {
      return null;
    }

    return h(
      '.main-menu-dropdown',
      {
        'data-bhw': 'MenuPopularStores',
      },
      [
        ...merchantsList,
        h(
          'a.main-menu-dropdown-link.view-all',
          {
            href: routes.all_brands.main,
            onClick: this.handleViewAllClick,
          },
          [
            h(Translate, 'js.modules.header.ViewAllMerchants'),
            h(
              'span.main-menu-dropdown-icon.view-all-icon.icon-arrow-right-large'
            ),
          ]
        ),
      ]
    );
  }
}

module.exports = hydrate('MainMenu', MainMenu);
